import * as faceapi from 'face-api.js';
import {throttle} from "../../../lib/rate";

export default {
  data: () => ({
    state: null,
    videoEl:null,
    weightsLoaded:false,
    faceDetections : [],
    faceDetectionActive: false
  }),
  created(){
    this.loadWeights();
  },
  mounted(){

  },
  methods: {
    loadWeights(){
      return faceapi.nets.tinyFaceDetector.loadFromUri('/weights').then(()=>{
        this.weightsLoaded=true;
      });
    },
    videoTrackReceived(videoEl){
      this.videoEl=videoEl;
      this.videoEl.addEventListener('play',this.onVideoElPlay);
    },
    onVideoElPlay(){
      this.startFaceDetection();
    },
    startFaceDetection(){
      let states=[];
      let detect;
      const maxFps = 3;
      this.faceDetectionActive=true;

      const getStateCounts = (states)=>{
        const stateCounts = {};
        for(let state of states){
          if(!stateCounts.hasOwnProperty(state)){
            stateCounts[state]=0;
          }
          stateCounts[state]++;
        }
        return stateCounts;
      };

      const getHighestCount = (stateCounts)=>{
        let maxValue=-1;
        let maxState=null;
        for(let state of Object.keys(stateCounts)){
          const cnt = stateCounts[state];
          if(cnt>maxValue){
            maxValue=cnt;
            maxState=state;
          }
        }
        return {
          state:maxState,
          count:maxValue,
        };
      };

      const threshold = 0.6;

      const emit = throttle(()=>{
        const result=getHighestCount(getStateCounts(states));
        const state=result.state;
        if(result.count/(states.length || 1) >= threshold){
          if(state=='notfound'){
            this.personNotFound();
          }else if(state=='multiple'){
            this.multipleFound();
          }else{
            this.stateNormal();
          }
        }
      },1000);

      const delayedFrame=(delayedBy)=>{
        setTimeout(() => {
          if(this.faceDetectionActive){
            requestAnimationFrame(detect);
          }
        }, delayedBy || (1000 / maxFps));
      };

      const bufferLength=3*(maxFps);


      detect=()=>{
        if(this.weightsLoaded && this.faceDetectionActive) {
          const canvasEl = faceapi.createCanvasFromMedia(this.videoEl);
          faceapi.detectAllFaces(canvasEl,new faceapi.TinyFaceDetectorOptions()).then((result) => {
            let state;
            if(result.length===0){
              state='notfound';
            }else if(result.length>1){
              state = 'multiple';
            }else{
              state = 'normal';
            }

            states.push(state);

            if(states.length > bufferLength){
              states.splice(0,1);
            }
            emit();

            delayedFrame();
          }).catch((err)=>{
            console.error(err);
          });
        }else{
          delayedFrame(1000);
        }
      };
      detect();
    },
    stopFacedetection(){
      if(this.videoEl){
        this.videoEl.removeEventListener('play',this.onVideoElPlay);
      }
      this.faceDetectionActive=false;
    }
  },
  beforeDestroy(){
    this.stopFacedetection();
  }
}